var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "20px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -420 -24 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 5.181286549707602  C 15 4.686159844054581  14.80078125 4.206627680311891  14.44921875 3.855750487329435  L 11.171875 0.5847953216374269  C 10.8203125 0.23391812865497075  10.34375 0.03508771929824561  9.84765625 0.03508771929824561  L 1.875 0.03508771929824561  C 0.83984375 0.03898635477582846  0 0.8771929824561403  0 1.9103313840155944  L 0 18.128654970760234  C 0 19.16179337231969  0.83984375 20  1.875 20  L 13.125 20  C 14.16015625 20  15 19.16179337231969  15 18.128654970760234  L 15 5.181286549707602  Z M 10 2.0623781676413255  L 12.97265625 5.029239766081871  L 10 5.029239766081871  L 10 2.0623781676413255  Z M 13 18  L 2 18  L 2 1.9103313840155944  L 8.125 1.9103313840155944  L 8.125 5.964912280701754  C 8.125 6.483430799220273  8.542968749999998 6.900584795321637  9.0625 6.900584795321637  L 13 6.900584795321637  L 13 18  Z ",
    fillRule: "nonzero",
    fill: "#ffffff",
    stroke: "none",
    transform: "matrix(1 0 0 1 420 24 )"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.dacb6d15bbff1be2955cb002cc0c6bb6.svg";
export { ForwardRef as ReactComponent };